import { Component } from '@angular/core';
import { ListNavigationComponent } from '../../../list-navigation/components/list-navigation/list-navigation.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-route-selector',
  templateUrl: './route-selector.component.html',
  styleUrls: ['./route-selector.component.scss'],
})
export class RouteSelectorComponent extends ListNavigationComponent {}
